export const exportHeaders = [
    { 
        label: "Table Name", 
        key:"table_name" 
    },
    {
        label: "Column Name",
        key: "column_name",
    },
    { 
        label: "Create", 
        key: "create" 
    },
    { 
        label: "Update", 
        key: "update" 
    },
    { 
        label: "Delete", 
        key: "delete" 
    },
    { 
        label: "Reason", 
        key: "reason"
    },
]



